module.exports = __webpack_public_path__ + "static/media/0024_IMG_TRAD_LES_ENSEIGNES_LE_FROMAGER_LETTRE_A_LETTRE.d096ae01.png";